import { takeLatest, put } from 'redux-saga/effects';
import handleStatusCode from 'Store/Api/HandleStatusCode';
import { PostFile } from 'Store/Api/CallApi';
import { ADMIN_UPLOAD_TEMPLATE } from 'Store/Api/ApiEndpoints';
import { REQUEST_UPLOAD_TEMPLATE, uploadTemplateSuccess } from 'Store/Areas/Template/UploadTemplateActions';

/* Worker Sagas */

function* postSelectedFile(action) {
  const formData = new FormData();
  formData.append('file', action.file);

  const response = yield PostFile(ADMIN_UPLOAD_TEMPLATE, formData);
  if (response.ok) {
    const data = yield response.json();
    yield put(uploadTemplateSuccess(data));
  } else {
    yield handleStatusCode(response.status);
  }
}

/* Watcher Sagas */
export function* uploadTemplateSagas() {
  yield takeLatest(REQUEST_UPLOAD_TEMPLATE, postSelectedFile);
}
